import { t } from '@moovly/i18n';
import * as React from 'react';
import { ModalContainer } from '@moovly/ui';
import { useDispatch } from 'react-redux';
import LicenseSlice from '../store/licenses.store';

export const useConsentOrderModal = () => {
  const [open, setOpen] = React.useState<boolean>(false);
  const confirm = React.useRef<(() => void) | null>(null);
  const ConsentOrderModal: React.FC<{ description: string }> = ({ description }) => {
    const dispatch = useDispatch<any>();
    const handleConfirm = React.useCallback(() => {
      if (confirm.current) confirm.current();
      confirm.current = null;
      setOpen(false);
    }, []);
    const handleClose = React.useCallback(() => {
      confirm.current = null;
      setOpen(false);
      dispatch(LicenseSlice.actions.resetPayment());
    }, [dispatch]);

    return (
      <ModalContainer
        setOpen={setOpen}
        description={description}
        isOpen={open}
        onConfirm={handleConfirm}
        onClose={handleClose}
        confirmButtonText={t('actions.proceed')}
        closeButtonText={t('actions.cancel')}
      />
    );
  };
  return {
    openConsentOrderModal: (cb: () => void) => {
      confirm.current = cb;
      setOpen(true);
    },
    ConsentOrderModal,
  };
};

export default useConsentOrderModal;
